/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<Publication, \'id\'>, schemaOptions: { title: \'NewPublication\', exclude: [ \'id\' ] })
 */
export interface NewPublication { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    name: string;
    description: string;
    coverPhotoUrl: string;
    fileUrl?: string;
    externalUrl?: string;
    discount?: string;
    showInPopup?: boolean;
    publishedOn?: string;
    expirationDate?: string | null;
    webPublishedOn?: string;
    published?: boolean;
    isPinned?: boolean;
    celebratedUserId?: number | null;
    yearsOfService?: number | null;
    publicationTypeId: string;
}

